import { kebabToCamelCase } from "@utils/stringFormat";
import { PATH_PAYABLES, PATH_RECEIVABLES } from "src/routes/paths";
import type { TAccountClass, TDocumentClass } from "../../core/types";

export const ACCOUNT_CLASS_ROUTE: Record<
  TAccountClass,
  "receivables" | "payables"
> = {
  AccountReceivable: "receivables",
  AccountPayable: "payables",
};

export const getDocumentClassRoute = (
  documentClass: TDocumentClass,
  accountClass: TAccountClass,
): string | null => {
  const isReceivable = accountClass === "AccountReceivable";
  switch (documentClass) {
    case "Invoice":
    case "CreditNote":
    case "DebitNote":
      return isReceivable ? "sale-invoice" : "purchase-invoice";
    case "DeliveryNote":
      return isReceivable ? "sale-delivery-note" : "purchase-deliverynote";
    case "PurchaseOrder":
      return "purchase-order";
    default:
      return null;
  }
};

export const getDocumentListingHref = (
  documentClass: TDocumentClass,
  accountClass: TAccountClass,
): string | undefined => {
  const accountClassRoute = ACCOUNT_CLASS_ROUTE[accountClass];
  const documentClassRoute = getDocumentClassRoute(documentClass, accountClass);
  const formattedDocumentClass = documentClassRoute
    ? kebabToCamelCase(documentClassRoute)
    : null;
  const listingEntry = formattedDocumentClass
    ? (accountClassRoute === "receivables" ? PATH_RECEIVABLES : PATH_PAYABLES)
        .general[formattedDocumentClass]
    : null;
  return typeof listingEntry === "string" ? listingEntry : listingEntry?.root;
};
